import React from 'react';

export const Link = () => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M10.6875 6.5C8.84614 6.5 3.6875 6.5 3.6875 6.5V19.5H16.6875C16.6875 19.5 16.6875 13.4983 16.6875 12.5'
            stroke='#38373C'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9.6875 13.5L19.6875 3.5'
            stroke='#38373C'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M14.6875 3.5H19.6875V8.5'
            stroke='#38373C'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
